import React, { Component } from "react";
import Head from "next/head";
import { connect } from "react-redux";
import withRouterPageLayout from "@components/withRouterPageLayout.js";

import {
  getSupportCategories,
  getSupportIndex,
  getSupportSearchArticles,
} from "@store/support/actions";
import SupportLayout from "@containers/Support/Layout";
import Breadcrumbs from "@components/Breadcrumbs";
import Heading from "@components/Heading";
import ErrorPage from "@containers/ErrorPage";
import ArticleCard from "@containers/Support/ArticleCard";
import TopArticles from "@containers/Support/TopArticles";

class SupportSearchPage extends Component {
  render() {
    const {
      searchParams,
      supportCategories,
      supportSearchArticles,
      topSupportArticles,
    } = this.props;

    if (!Object.keys(searchParams).length) {
      return <ErrorPage layout="404" />;
    }

    const { qs: word, ts: tag } = searchParams;
    const pageHeading = `Rezultate cautare : ${word || tag}`;

    return (
      <>
        <Head>
          <title>{pageHeading}</title>
        </Head>

        <Breadcrumbs
          breadcrumbs={[
            {
              id: 1,
              level: 2,
              name: `Suport clienti`,
              url_key: "suport-clienti/",
            },
            {
              id: 1,
              level: 99,
              name: `Rezultate cautare`,
            },
          ]}
        />

        <SupportLayout categories={supportCategories} hasTitle={false}>
          <section className="py-6">
            <div className="mb-6">
              <Heading title={pageHeading} as="h1" display="h1" />
            </div>

            {supportSearchArticles && supportSearchArticles.length ? (
              supportSearchArticles.map((item) => (
                <ArticleCard
                  key={item.slug}
                  item={item}
                  articleSlug={item.slug}
                />
              ))
            ) : (
              <>
                <div className="mt-3 Alert">
                  <p>
                    Nu au fost gasite rezultate. In schimb, acestea sunt cele
                    mai citite articole de suport:
                  </p>
                </div>

                {topSupportArticles && (
                  <section className="pt-12">
                    <TopArticles items={topSupportArticles} />
                  </section>
                )}
              </>
            )}
          </section>
        </SupportLayout>
      </>
    );
  }
}

SupportSearchPage.pageLayout = "default";

SupportSearchPage.getInitialProps = async (ctx) => {
  const { reduxStore, query } = ctx;
  const { qs, ts } = query;
  const searchParams = (qs && { qs }) || (ts && { ts }) || {};

  // Get data from store
  const { categories, topArticles, searchArticles } =
    reduxStore.getState().support;
  const promises = [];

  // Load data
  !categories && promises.push(reduxStore.dispatch(getSupportCategories()));
  promises.push(reduxStore.dispatch(getSupportSearchArticles(searchParams)));

  if (!searchArticles || !searchArticles.length || !topArticles) {
    promises.push(reduxStore.dispatch(getSupportIndex()));
  }

  await Promise.all(promises);

  return {
    searchParams,
  };
};

export default withRouterPageLayout(
  connect((state) => ({
    supportCategories: state.support.categories,
    supportSearchArticles: state.support.searchArticles,
    topSupportArticles: state.support.topArticles,
  }))(SupportSearchPage)
);
